<div class="container">
  <div style="text-align: center;">
    <button mat-flat-button [ngClass]="{'select-part': true, 'selected-part': selected === 1}" (click)="selectPart(1)">Expériences signalées</button>
    <button mat-flat-button [ngClass]="{'select-part': true, 'selected-part': selected === 2}" (click)="selectPart(2)">Utilisateurs signalés</button>
  </div>
  <app-reported-experience *ngIf="selected === 1"></app-reported-experience>
  <app-reported-user *ngIf="selected === 2"></app-reported-user>
</div>
